export default __webpack_public_path__ + "assets/models/e74ae17dbf8bcae785cdfdb467b6423a.glb";